import { HttpErrorResponse } from '@angular/common/http';

export enum ErrorCode {
    Default = '0', // Default error handler
    ProgressEvent = '1000',

    // 4xx Client Errors
    BadRequest = '400', // Invalid GUID
    NotFound = '404', // Invalid GUID
    Conflict = '409', // Claim Not Actionable
    Gone = '410', // Claim Not Actionable

    // 5xx Server Errors
    InternalServerError = '500',
    NotImplemented = '501',
    BadGateway = '502',
    ServiceUnavailable = '503',
    GatewayTimeout = '504',
}

export interface ExtendedServerErrorResponse extends HttpErrorResponse {
    error: ServerErrorResponse;
}

export interface ServerErrorResponse {
    status: string;
    message: string;
    errorCode: ErrorCode;
    errors?: Record<string, string[]>;
}
